import { getJson } from "../../../utils";
import { constants } from "../common";
import { ApiResponseWithData, BasketResponse } from "./api/models";
import { setBasketExpiryTimer } from "./setBasketExpiryTimer";
import dayJs from "dayjs";

export async function startExpiryTimer() {
    const response = await getJson<ApiResponseWithData<BasketResponse>>(constants.urls.basketV2.get);
    setBasketExpiryTimer(dayJs(response.data.expiryTime));
}